import { CollectionUUID, Recipe, RecipeUUID } from '@library/menu-service'

import { useCollectionRecipeSets } from 'hooks/menu-collections'
import { useOfferedRecipes } from 'hooks/menu-recipes/useOfferedRecipes'

export type EnrichedRecipeSet = {
  id: string
  recipeIds: Set<RecipeUUID>
  baseRecipe: Recipe
  options: Recipe[]
}

const generateRecipeSetId = (recipes: Recipe[]) => {
  const coreIds = recipes.map((recipe) => recipe.coreId)

  const uniqueIds = new Set(coreIds)
  const sortedIds = Array.from(uniqueIds).sort()

  return `recipe_family_reference_${sortedIds.join(',')}`
}

export const useCollectionEnrichedRecipeSets = (
  collectionId: CollectionUUID | null,
): EnrichedRecipeSet[] => {
  const collectionRecipeSets = useCollectionRecipeSets(collectionId)
  const recipes = useOfferedRecipes()

  return collectionRecipeSets
    .map(({ baseRecipeId, recipeIds }) => {
      const baseRecipe = recipes[baseRecipeId] || null
      if (!baseRecipe) {
        return null
      }

      const allRecipes = Array.from(recipeIds)
        .map((option) => recipes[option] || null)
        .filter((option): option is Recipe => Boolean(option))

      return {
        id: generateRecipeSetId(allRecipes),
        recipeIds,
        baseRecipe,
        options: allRecipes.filter((recipe) => recipe.id !== baseRecipe.id),
      }
    })
    .filter((recipeSet): recipeSet is EnrichedRecipeSet => recipeSet !== null)
}
